import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaV3Module } from 'ng-recaptcha';
import { DirectiveModule } from '../../directives/directive.module';
import { AngularMaterialModule } from '../../material.module';
import { PipeModule } from '../../pipe/pipe.module';
import { ImagesliderComponent } from '../imageslider/imageslider.component';
import { KeywordsModule } from '../keywords/keywords.module';
import { ToolsModule } from '../tools/tools.module';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { CustomemailComponent } from './customemail/customemail.component';
import { FlugDetailComponent } from './flugdetail/flugdetail.component';
import { GiftCardModalComponent } from './giftCard/giftCard.component';
import { HotelinfoComponent } from './hotelinfo/hotelinfo.component';
import { HotelreviewComponent } from './hotelreview/hotelreview.component';
import { MapcomponentComponent } from './mapcomponent/mapcomponent.component';
import { NewlettermodalComponent } from './newlettermodal/newlettermodal.component';
import { OfferpackformComponent } from './offerpackform/offerpackform.component';
import { ParkinginfoComponent } from './parkinginfo/parkinginfo.component';
import { PartnerloginComponent } from './partnerlogin/partnerlogin.component';
import { PreisalarmmodalComponent } from './preisalarmmodal/preisalarmmodal.component';
import { SvgmapinfoComponent } from './svgmapinfo/svgmapinfo.component';
import { TerminComponent } from './termin/termin.component';
import { TvangebotimagevideoComponent } from './tvangebotimagevideo/tvangebotimagevideo.component';
@NgModule({
  declarations: [
    MapcomponentComponent,
    HotelreviewComponent,
    SvgmapinfoComponent,
    ParkinginfoComponent,
    TvangebotimagevideoComponent,
    TerminComponent,
    PartnerloginComponent,
    HotelinfoComponent,
    OfferpackformComponent,
    CustomemailComponent,
    FlugDetailComponent,
    NewlettermodalComponent,
    ConfirmationComponent,
    PreisalarmmodalComponent,
    GiftCardModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    DirectiveModule,
    RecaptchaV3Module,
    PipeModule,
    ImagesliderComponent,
    ToolsModule,
    KeywordsModule,
  ],
  exports: [MapcomponentComponent, HotelreviewComponent],
})
export class ModalsModule {}
